import { createBrowserRouter } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import CitySelectionPage from './pages/city/CitySelectionPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ProfilePage from './pages/profile/ProfilePage';
import ProviderPage from './pages/provider/ProviderPage';
import CityHallPage from './pages/city-hall/CityHallPage';
import SpecialistsPage from './pages/specialists/SpecialistsPage';
import ServicesPage from './pages/services/ServicesPage';
import ServiceRequestPage from './pages/services/ServiceRequestPage';
import RegistrationPage from './pages/registration/RegistrationPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <LoginPage />
  },
  {
    path: '/signup',
    element: <SignupPage />
  },
  {
    path: '/registration',
    element: <RegistrationPage />
  },
  {
    path: '/city-selection',
    element: <CitySelectionPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/prestador/:id',
    element: <ProviderPage />
  },
  {
    path: '/prefeitura/:city',
    element: <CityHallPage />
  },
  {
    path: '/especialistas',
    element: <SpecialistsPage />
  },
  {
    path: '/servicos',
    element: <ServicesPage />
  },
  {
    path: '/servicos/nova-solicitacao',
    element: <ServiceRequestPage />
  }
]);

export default router;